import React, { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';

import { ActivityTypes } from 'enums/types';

import InfoSection from '../InfoSection';

export default function SectionTable({ data, ...rest }) {
  const freight = useMemo(() => [
    ...(data?.deliveryFreight || []),
    ...(data?.dispatchFreight || []),
    ...(data?.transhipmentFreight || []),
    ...(data?.collectedFreight || []),
  ], [data]);

  return (
    <Flex
      flexDir="column"
      {...rest}>
      {freight?.map((item) => (
        <InfoSection
          name={item.material?.name}
          packaging={item.packaging}
          amount={item.amount}
          barCode={item.barCode}
          container={item.container?.name}
          temperature={
              data?.type !== ActivityTypes.Collect
                ? item.finalTemperature ?? item.temperature
                : item.temperature
            }
          type={item.material?.type}
          value={[...new Set(item.imageUrls)]}
          patients={item.patients}
          status={item.status}
        />
      ))}
    </Flex>
  );
}
